<template>
  <div>
    <hr class="hr-stil">
    <div>
      <el-dialog
        top="30vh"
        width="530px"
        append-to-body
        class="uspesno-obvestilo mobile"
        :visible.sync="centerDialogVisible"
        center>
        <div class="ikona-uspesno">
          <img src="/static/img/MojT2/Eposlovanje/Icon-feather-alert-circle.png">
        </div>
        <div style="padding-bottom: 48px">
          <p class="navadno-besedilo text-block-center okno-center">
            Ob vklopu direktne bremenitve računov ne pošiljamo po navadni pošti.
            <span>
              Prosimo, izberite prejemanje po elektronski pošti in vpišite vaš e-naslov.
            </span>
          </p>
        </div>
        <div style="text-align: center; margin-bottom: 10px;">
          <el-button class="gumb-brez-obrob krepko crna" @click="centerDialogVisible = false">
            Prekliči
          </el-button>
        </div>
      </el-dialog>
    </div>
    <div class="postavitev-prejemanje-racunov"  v-loading="pridobivanjeObvescanjaStranke">
      <p class="open-sans-30pt" id="nacin-prejema">
        Prejemanje računov
      </p>
      <div class="prejemanje-racunov-odmik-besedila">
        <p class="navadno-besedilo">
          Račune lahko prejemate po elektronski pošti, v portal Moj T-2 ali navadni pošti.
          Pri navadni pošti lahko tudi vpišete alternativni naslov, ki ni enak vašemu stalnemu naslovu.
        </p>
      </div>
      <div class="odmik-top-20">
        <el-radio label="1" v-model="nacinObvescanjaStranke" :disabled="eBanka" v-if="!eBanka">
          Po elektronski pošti
        </el-radio>
        <el-radio label="3" v-model="nacinObvescanjaStranke">
          Moj T-2
        </el-radio>
        <el-radio label="0" v-model="nacinObvescanjaStranke" v-if="!direktnaBremenitev && !eBanka"
                  :disabled="direktnaBremenitev || eBanka">
          Po navadni pošti
        </el-radio>
      </div>
      <div v-if="eBanka === false">
        <div v-if="nacinObvescanjaStranke ==='1' || direktnaBremenitev === true"
             class="prejemanje-racunov-odmik-besedila">
          <div v-if="nacinObvescanjaStranke === '1'">
            <p>
              Elektronski naslov za prejemanje računov
            </p>
            <el-input placeholder="Vnesite elektronski naslov." class="velikost-input-prejemanje-racunov" type="text"
                      v-model="eracunEmail">
            </el-input>
          </div>
          <div class="postavitev-gumba-shrani-spremembe"
               v-if="nacinObvescanjaStranke === '1' || nacinObvescanjaStranke === '0'">
            <el-button class="gumb-potrdi" v-on:click="NacinPosiljanjaRacuna">
              SHRANITE SPREMEMBE
            </el-button>
          </div>
        </div>
        <div v-if="nacinObvescanjaStranke === '3'">
          <div class="postavitev-gumba-shrani-spremembe">
            <el-button class="gumb-potrdi" v-on:click="NacinPosiljanjaRacuna">
              SHRANITE SPREMEMBE
            </el-button>
          </div>
        </div>
        <div v-if="nacinObvescanjaStranke ==='0'&& direktnaBremenitev === false" style="clear: both; padding-top: 30px">
          <div>
            <p class="navadno-besedilo">
              Če ne želite prejemati računov na vaš stalni naslov, lahko vpišete
              alternativni naslov.
            </p>
            <el-form label-width="160px" :label-position="formaOrientacija">
              <el-form-item label="Vnesite naslov:" class="label-mobile">
                <el-select @change="PreverjanjeNaslova(stalenNaslov)"
                           :remote-method="PredlaganStalenNaslov"
                           filterable
                           placeholder="Vnesite naslov"
                           remote
                           reserve-keyword
                           class="velikost-input-prejemanje-racunov"
                           v-model="stalenNaslov">
                  <el-option
                    v-for="item in naslovi"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Hišna številka:" class="label-mobile">
                <el-input type="text"
                          v-model="hs"
                          placeholder="Vnesite hišno številko"
                          maxlength="7"
                          class="velikost-input-prejemanje-racunov">
                </el-input>
              </el-form-item>
            </el-form>
            <div class="postavitev-gumba-shrani-spremembe">
              <el-button class="gumb-potrdi" v-on:click="NacinPosiljanjaRacuna">
                SHRANITE SPREMEMBE
              </el-button>
            </div>
          </div>
        </div>
        <div class="postavitev-statusa">
          <b>
            <i>
              <img :src="ikonaStatusObvescanje" class="Icon-awesome"/>
            </i>
            STATUS:
          </b>
          {{ statusObvescanje }}
        </div>
      </div>
      <div v-if="eBanka === true">
        <InfoKomponentaPrejemanjeRacunovEbanka/>
      </div>
      <div v-if="(direktnaBremenitev && !eBanka) || (!direktnaBremenitev && eBanka)">
        <InfoKomponentaPrejemanjeRacunovDirektnaBremenitev/>
      </div>
    </div>
    <hr class="hr-stil">
    <div class="postavitev-spletna-banka-bremenitev-sepa" v-loading="nalaganjeSepaPodatkov">
      <div>
        <div>
          <p class="open-sans-30pt">
            Vročanje računov v spletno banko / Direktna bremenitev (SEPA)
          </p>
        </div>
        <div style="padding-top: 20px">
          <p class="navadno-besedilo">
            Za vklop vročanja računov v spletno banko in/ali vklop direktne obremenitve, prosimo, vpišite
            najprej vaše podatke transakcijskega računa.
          </p>
        </div>
        <div class="odmik-forme-sepa">
          <div class="podatki">
            <div>
              <p class="odmik-bottom">
                TRR:
              </p>
              <el-input placeholder="Vnesite TRR" v-bind:disabled="onemegocenObrazec" class="velikost-input"
                        maxlength="15" type="text" v-model="trr">
                <template slot="prepend">
                  SI56
                </template>
              </el-input>
            </div>
            <div>
              <p class="odmik-bottom">
                Ime in priimek / naziv:
              </p>
              <el-input placeholder="Vnesite ime in priimek" type="text" class="velikost-input"
                        v-bind:disabled="onemegocenObrazec"
                        v-model="imePriimek">
              </el-input>
            </div>
            <div>
              <p class="odmik-bottom">
                Naslov:
              </p>
              <el-select @change="PreverjanjeNaslova(naslovSpletnaBankaDirektnaBremenitev)"
                         :disabled="onemegocenObrazec"
                         :remote-method="PredlaganStalenNaslov"
                         filterable
                         placeholder="Vnesite naslov"
                         remote
                         class="velikost-input"
                         reserve-keyword
                         v-model="naslovSpletnaBankaDirektnaBremenitev">
                <el-option
                  v-for="item in naslovi"
                  :key="item"
                  :label="prikazanNaslov(item)"
                  :value="item">
                </el-option>
              </el-select>
            </div>
            <div>
              <p class="odmik-bottom">
                Hišna številka:
              </p>
              <el-input type="text"
                        v-bind:disabled="onemegocenObrazec"
                        v-model="hs2"
                        placeholder="Vnesite hišno številko"
                        class="velikost-input"
                        maxlength="7">
              </el-input>
            </div>
          </div>
        </div>
        <hr class="hr-stil">
        <div style="padding-top: 30px; padding-bottom: 25px">
          <p class="open-sans-20pt">
            Vročanje računov v spletno banko
          </p>
          <div style="padding-top: 30px">
            <p class="navadno-besedilo">
              Račun se izda v elektronski obliki in pošlje v vašo spletno banko, kjer izvedete plačilo.
            </p>
          </div>
          <div style="padding-top: 10px">
            <el-checkbox v-model="eBanka" v-bind:disabled="onemegocenObrazec" v-on:change="SetMetodaPlacila">
            </el-checkbox>
            <b style="color: #f58220">
              Da</b>,
            <span class="flex-odmik vrocanje">želim vročanje računov v spletno banko.</span>
          </div>
          <div class="postavitev-statusa">
            <b>
              <i>
                <img :src="ikonaZaPrikazStatusaVspletnoBanko" class="Icon-awesome"/>
              </i>
              STATUS:
            </b>
            {{ statusVrocanjaVspletnoBanko }}
          </div>
        </div>
        <!--
         <div v-show="onemogocenInfo" class="sirok" style="padding-top: 35px; padding-bottom: 44px;">
          <info-komponenta-casovnica-sprememb-vrocanje/>
        </div>
        -->
        <hr class="hr-stil">
        <div style="clear: both"/>
        <div v-loading="nalaganjeSepaPodatkov" style="padding-top: 20px; padding-bottom: 20px">
          <p class="open-sans-20pt">
            Direktna bremenitev (SEPA)
          </p>
          <div style="padding-top: 30px">
            <p class="navadno-besedilo">
              Z vklopom direktne bremenitve (trajnika) omogočamo plačevanje računov direktno z vašega
              transakcijskega računa. <b>Plačilo računov se izvaja 18. v mesecu.</b> <br/>
              Specifikacije računov pošiljamo na vaš elektronski naslov ali v spletno banko.
              Do izdanih računov lahko kadarkoli dostopate v meniju
              <a href="/MojT2/Racuni" class="primarna-barva" style="cursor: pointer">
                Izdani računi</a>.
            </p>
          </div>
          <div style="padding-top: 10px">
            <el-checkbox v-model="direktnaBremenitev" v-bind:disabled="onemegocenObrazec"
                         v-on:change="SetMetodaPlacila">
            </el-checkbox>
            <b style="color: #f58220">
              Da</b>,
            želim vklopiti direktno bremenitev.
          </div>
          <div class="postavitev-statusa">
            <b>
              <i>
                <img :src="ikonastatusDirektnaBremenitev" class="Icon-awesome"/>
              </i>
              STATUS:
            </b>
            {{ statusDirektnaBremenitev }}
          </div>
        </div>
        <div style="clear: both"/>
        <div style="padding-top: 40px; padding-bottom: 20px">
          <el-button class="gumb-potrdi"
                     v-if="(spremembaUrejanjaEbanka || spremembaUrejanjaDirektnaBremenite) && !onemegocenObrazec && mozenPreklicSepa === '0'"
                     type="primary" v-on:click="NastavitevSEPApodatkovStrankeRacun">
            SHRANITE SPREMEMBE
          </el-button>
          <a class="stil-gumb-preklici"
             v-if="(spremembaUrejanjaEbanka || spremembaUrejanjaDirektnaBremenite) && !onemegocenObrazec && mozenPreklicSepa === '0'"
             v-on:click="PreklicUrejanjeSpletnaBankaSepa" type="primary">
            Prekliči
          </a>
          <div class="postavitev-gumb-preklic-sepa">
            <a class="okvir-preklica-sepe tekst-okvir-izklopa-sepe"
               v-if="sepaPodatki !== null && mozenPreklicSepa === '1'"
               v-on:click="PreklicSepa">
              PREKLIC SEPA
            </a>
          </div>
        </div>
        <div style="clear: both"/>
      </div>
      <div v-show="onemogocenInfo" class="sirok">
        <info-komponenta-casovnica-sprememb/>
      </div>
    </div>
  </div>
</template>
<script>
import {SirinaOkna} from 'src/assets/js/globalne_funkcije/SirinaOkna.js'
import {povezave} from '../../../../../assets/js/Povezave/povezave'
import Validacija from 'src/assets/js/globalne_funkcije/Validacija.js'
import {
  Input,
  Radio,
  RadioGroup,
  Switch,
  Button,
  Form,
  Alert,
  Icon,
  Loading,
  Select,
  Option,
  Checkbox, MessageBox, Dialog
} from 'element-ui'
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import InfoKomponentaPrejemanjeRacunovEbanka from './InfoKomponentaPrejemanjeRacunovEbanka'
import InfoKomponentaPrejemanjeRacunovDirektnaBremenitev from './InfoKomponentaPrejemanjeRacunovDirektnaBremenitev'
import InfoKomponentaCasovnicaSprememb from './InfoKomponentaCasovnicaSprememb'
import InfoKomponentaCasovnicaSpremembVrocanje from './InfoKomponentaCasovnicaSpremembVrocanje'

export default {
  name: 'eRacunComponenta',
  mixins: [SirinaOkna],
  data () {
    return {
      mejnaSirina: 1400,
      formaOrientacija: 'left',
      clientAgent: null,
      eracunEmail: '',
      eracunEmailPotrjen: '',
      direktnaBremenitev: false,
      eBanka: false,
      pridobljenaDirektnaBremenitev: false,
      pridobljenaeBanka: false,
      imePriimek: '',
      metodaPlacila: '',
      nacinObvescanjaStranke: '',
      nacinObvescanjaStrankePotrjeno: '',
      zacetekSepa: '',
      stalenNaslov: '',
      naslovSpletnaBankaDirektnaBremenitev: '',
      naslovi: [],
      hs: '',
      hsPotrjena: '',
      hs2: '',
      pridobivanjeObvescanjaStranke: false,
      hd: '',
      stranUrl: '',
      trr: '',
      onemegocenObrazec: false,
      currentDate: new Date(),
      nalaganjeSepaPodatkov: false,
      validacija: null,
      statusObvescanje: '',
      statusVrocanjaVspletnoBanko: '',
      statusDirektnaBremenitev: '',
      mozenPreklicSepa: '0',
      vrocanjeRacunoEbankeVkljuceno: 'Vročanje računov preko E-BANKE je vključeno',
      vrocanjeRacunoEbankeIzkljuceno: 'Vročanje računov preko E-BANKE je izključeno.',
      direktnaBremenitevVkljucena: 'Direktna bremenitev je vključena',
      direktnaBremenitevIzkljucena: 'Direktna bremenitev je izključena.',
      ikonastatusDirektnaBremenitev: '',
      ikonaZaPrikazStatusaVspletnoBanko: '',
      ikonaStatusObvescanje: '',
      ikonaZaPrikazStatusaKljukica: '/static/img/kljukica2.svg',
      ikonaZaPrikazStatusaInfoKrogec: '/static/img/UporabniskiKoticek/UporabneStrani/Icon-awesome-info-circle.png',
      ikonaZaPrikazStatusaInfoTrikotnik: '/static/img/Domov/Icon-awesome-exclamation-triangle-black.png',
      centerDialogVisible: false,
      vrocanjeVSpletnoBanko: false,
      onemogocenInfo: false,
      spremembaUrejanjaDirektnaBremenite: false,
      spremembaUrejanjaEbanka: false,
      sepaPodatki: null,
      stalenNaslovPotrjen: ''
    }
  },
  props: {
    izbranaStranka: null,
    izbranaStrankaSap: null
  },
  components: {
    InfoKomponentaCasovnicaSpremembVrocanje,
    InfoKomponentaCasovnicaSprememb,
    InfoKomponentaPrejemanjeRacunovDirektnaBremenitev,
    InfoKomponentaPrejemanjeRacunovEbanka,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Input.name]: Input,
    [Form.name]: Form,
    [Switch.name]: Switch,
    [Select.name]: Select,
    [Option.name]: Option,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Alert.name]: Alert,
    [Icon.name]: Icon,
    [Loading.name]: Loading,
    [Dialog.name]: Dialog
  },
  watch: {
    izbranaStrankaSap () {
      if (this.izbranaStrankaSap !== null) {
        this.refreshPodatkov()
      }
    },
    orientacija (val) {
      this.formaOrientacija = val
    },
    eBanka (val) {
      this.spremembaUrejanjaEbanka = val
    },
    direktnaBremenitev (val) {
      this.spremembaUrejanjaDirektnaBremenite = val
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.validacija = new Validacija()
    this.stranUrl = povezave.BASE_URL_T2_STRAN
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
    this.refreshPodatkov()
  },
  methods: {
    PreklicUrejanjeSpletnaBankaSepa () {
      this.PridobitevTrenutnihStrankinihSEPApodatkov()
      this.spremembaUrejanjaEbanka = false
      this.spremembaUrejanjaDirektnaBremenite = false
    },
    refreshPodatkov () {
      this.PridobitevTrenutnihStrankinihSEPApodatkov()
      this.ObvescanjaStranke()
      this.ulica = ''
      this.hs = ''
      this.hsPotrjena = ''
      this.pst = ''
      this.pKraj = ''
      this.statusVrocanjaVspletnoBanko = ''
      this.statusDirektnaBremenitev = ''
      this.direktnaBremenitev = false
      this.pridobljenaDirektnaBremenitev = false
      this.pridobljenaeBanka = false
      this.eBanka = false
      this.onemegocenObrazec = false
      this.naslovSpletnaBankaDirektnaBremenitev = ''
    },
    ObvescanjaStranke () {
      if (this.izbranaStrankaSap !== '') {
        this.pridobivanjeObvescanjaStranke = true
        let param = ['idStranka=' + this.izbranaStranka]
        this.clientAgent.postWsRequest(
          this,
          'stranka/eracun/getNacinObvescanja',
          param,
          null,
          'SetObvescanjaStranke',
          'ErrObvescanjaStranke')
      }
    },
    SetObvescanjaStranke (podatki) {
      this.nacinObvescanjaStranke = podatki.eracun
      this.nacinObvescanjaStrankePotrjeno = podatki.eracun
      this.statusObvescanje = ''
      this.stalenNaslov = ''
      this.stalenNaslovPotrjen = ''
      this.eracunEmail = ''
      this.eracunEmailPotrjen = ''
      if (podatki.eracun === 1) {
        this.nacinObvescanjaStranke = '1'
        this.eracunEmail = podatki.eracunEmail
        this.stalenNaslov = ''
        this.hs = ''
        this.statusObvescanje = 'Vklopljeno je prejemanje računov na vaš elektronski naslov.'
        this.ikonaStatusObvescanje = this.ikonaZaPrikazStatusaKljukica
      } else if (podatki.eracun === 0) {
        this.nacinObvescanjaStranke = '0'
        this.eracunEmail = ''
        this.statusObvescanje = 'Vklopljeno je prejemanje računov po navadni pošti.'
        this.ikonaStatusObvescanje = this.ikonaZaPrikazStatusaKljukica
      } else if (podatki.eracun === 3) {
        this.statusObvescanje = 'Vklopljeno je prejemanje računov v Moj T-2.'
        this.ikonaStatusObvescanje = this.ikonaZaPrikazStatusaKljukica
        this.nacinObvescanjaStranke = '3'
      } else {
        this.statusObvescanje = 'Izključeno.'
        this.ikonaStatusObvescanje = this.ikonaZaPrikazStatusaInfoKrogec
      }
      this.nacinObvescanjaStrankePotrjeno = this.nacinObvescanjaStranke
      this.eracunEmailPotrjen = this.eracunEmail
      if (typeof podatki.hs !== 'undefined') {
        this.hs = podatki.hs
      }
      if (typeof podatki.hd !== 'undefined') {
        this.hs = this.hs + podatki.hd
      }
      this.hsPotrjena = this.hs
      this.stalenNaslov = podatki.ulica + ' ' + podatki.kraj + ' ' + podatki.pst + ' ' + podatki.pKraj
      this.stalenNaslovPotrjen = this.stalenNaslov
      this.pridobivanjeObvescanjaStranke = false
    },
    ErrObvescanjaStranke (podatki) {
      this.ShowWarningMessage(podatki)
      this.pridobivanjeObvescanjaStranke = false
    },
    PredlaganStalenNaslov (preverjanje) {
      if (preverjanje.length > 3 && preverjanje !== '') {
        this.ulice = preverjanje
        let param = ['delniNaziv=' + this.ulice]
        this.clientAgent.postWsRequest(this,
          'autocomplete/naslov/Naslov',
          param,
          null,
          'SetPredlaganStalenNaslov',
          'ErrPredlaganStalenNaslov')
      } else {
        this.naslovi = []
      }
    },
    SetPredlaganStalenNaslov (podatki) {
      this.naslovi = podatki.data
    },
    ErrPredlaganStalenNaslov (podatki) {
      this.ShowWarningMessage(podatki)
    },
    SetMetodaPlacila () {
      if (this.eBanka) this.nacinObvescanjaStranke = '1'
      if (this.nacinObvescanjaStranke === '1') {
        let paramObvestilo = {}
        if (this.mozenPreklicSepa === '1') {
          paramObvestilo.message = 'Za urejanje prekličite SEPO.'
        } else {
          paramObvestilo.message = 'Potrdite spremembe s klikom na gumb SHRANITE SPREMEMBE.'
        }
        if (this.pridobljenaDirektnaBremenitev !== this.direktnaBremenitev) {
          this.spremembaUrejanjaDirektnaBremenite = true
          this.ShowWarningMessage(paramObvestilo)
        } else if (this.pridobljenaeBanka !== this.eBanka) {
          this.spremembaUrejanjaEbanka = true
          this.ShowWarningMessage(paramObvestilo)
        } else {
          this.spremembaUrejanjaDirektnaBremenite = false
          this.spremembaUrejanjaEbanka = false
        }
        if (this.direktnaBremenitev === true && this.eBanka === true) {
          this.metodaPlacila = 'ZCe'
        } else if (this.direktnaBremenitev === true) {
          this.metodaPlacila = 'ZCc'
        } else if (this.eBanka === true) {
          this.metodaPlacila = 'EBA'
        } else {
          this.metodaPlacila = ''
        }
      }
      if (this.vrocanjeVSpletnoBanko === false && this.direktnaBremenitev === true &&
        this.nacinObvescanjaStranke === '0') {
        this.centerDialogVisible = true
        this.direktnaBremenitev = false
      }
    },
    PreverjanjeNaslova (naslov) {
      let pattern = new RegExp(/^([^,]+)(?:[,]+)[\s]*(?:([^,\d]*),)?[\s]*([\d]{4})\s(.*)/i)
      return naslov.split(pattern)
    },
    NacinPosiljanjaRacuna () {
      let obstajajoSpremembe = this.stalenNaslov !== this.stalenNaslovPotrjen || this.hsPotrjena !== this.hs ||
                               this.nacinObvescanjaStrankePotrjeno !== this.nacinObvescanjaStranke ||
                               this.eracunEmailPotrjen !== this.eracunEmail
      if (obstajajoSpremembe) {
        if (this.nacinObvescanjaStranke === '1') {
          let paramObvestilo = {}
          if (this.eracunEmail === '') {
            paramObvestilo.message = 'Neuspešen vklop eRačuna! Prosimo, vpišite elektronski naslov.'
            this.ShowErrorMessage(paramObvestilo)
            return
          } else if (!this.validacija.EmailValid(this.eracunEmail)) {
            paramObvestilo.message = 'Neuspešen vklop eRačuna! Prosimo, preverite ustreznost vpisa elektronskega naslova.'
            this.ShowErrorMessage(paramObvestilo)
            return
          }
        }
        if (this.nacinObvescanjaStranke === '0') {
          if (!this.validacija.HisnaStevilkaValidation(this.hs)) {
            let paramObvestilo = {}
            paramObvestilo.message = 'Vpisali ste hišno številko ki je še nimamo zabeležene v sistemu. Prosimo,' +
              'preverite vpisano številko.'
            this.ShowWarningMessage(paramObvestilo)
          }
          let naslov = this.PreverjanjeNaslova(this.stalenNaslov)
          if (naslov.length === 6) {
            if (naslov[1] !== '' && naslov[2] !== '' && naslov[3] !== '' && naslov[4] !== '') {
              this.ulica = naslov[1]
              this.kraj = naslov[2]
              this.pst = naslov[3]
              this.pKraj = naslov[4]
            } else if (naslov[1] !== '' && naslov[3] !== '' && naslov[4] !== '') {
              this.ulica = naslov[1]
              this.kraj = naslov[4]
              this.pst = naslov[3]
              this.pKraj = naslov[4]
            } else {
              let paramObvestilo = {}
              paramObvestilo.message = 'Vpisan naslov ni pravilen'
              this.ShowWarningMessage(paramObvestilo)
              return false
            }
          }
        }
        if (this.izbranaStrankaSap !== '') {
          let param = ['idStranka=' + this.izbranaStranka]
          if (this.nacinObvescanjaStranke === '0') {
            param.push('ulica=' + this.ulica)
            param.push('hs=' + this.hs)
            param.push('pst=' + this.pst)
            param.push('pKraj=' + this.pKraj)
            param.push('kraj=' + this.pKraj)
            param.push('eracun=' + this.nacinObvescanjaStranke)
          } else {
            param.push('eracunEmail=' + this.eracunEmail)
            param.push('eracun=' + this.nacinObvescanjaStranke)
          }
          this.clientAgent.postWsRequest(
            this,
            'stranka/eracun/setNacinObvescanja',
            param,
            null,
            'SetNacinPosiljanjaRacuna',
            'ErrNacinPosiljanjaRacuna')
        }
      } else {
        let paramObvestilo = {}
        paramObvestilo.message = 'V izbiri načina prejemanja računov ni bilo izvedenih nobenih sprememb.'
        this.ShowWarningMessage(paramObvestilo)
      }
    },
    SetNacinPosiljanjaRacuna () {
      this.ObvescanjaStranke()
      let paramObvestilo = {}
      paramObvestilo.message = 'Spremembe podatkov za prejemanje računov so bile uspešno izvedene.'
      this.ShowSuccessMessage(paramObvestilo)
    },
    ErrNacinPosiljanjaRacuna (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    PridobitevTrenutnihStrankinihSEPApodatkov () {
      if (this.izbranaStrankaSap !== '') {
        this.nalaganjeSepaPodatkov = true
        let param = ['idStranka=' + this.izbranaStranka]
        this.clientAgent.postWsRequest(
          this,
          'stranka/eracun/getSepaPodatki',
          param,
          null,
          'SetPridobitevTrenutnihStrankinihSEPApodatkov',
          'ErrPridobitevTrenutnihStrankinihSEPApodatkov')
      }
    },
    prikazanNaslov (celotenNaslov) {
      let naslov = celotenNaslov.split(',')
      return (naslov[0] + ', ' + naslov[2]).toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())
    },
    SetPridobitevTrenutnihStrankinihSEPApodatkov (podatki) {
      this.mozenPreklicSepa = '0'
      this.sepaPodatki = podatki.data
      if (podatki !== '' && podatki !== null && typeof podatki !== 'undefined') {
        this.ikonastatusDirektnaBremenitev = this.ikonaZaPrikazStatusaInfoKrogec
        this.ikonaZaPrikazStatusaVspletnoBanko = this.ikonaZaPrikazStatusaInfoKrogec
        this.naslovSpletnaBankaDirektnaBremenitev = ''
        this.trr = ''
        this.imePriimek = ''
        this.metodaPlacila = ''
        this.direktnaBremenitev = false
        this.eBanka = false
        this.pridobljenaDirektnaBremenitev = false
        this.pridobljenaeBanka = false
        if (podatki.data.length !== 0) {
          this.naslovSpletnaBankaDirektnaBremenitev = podatki.data.ulica + ' ' + podatki.data.kraj + ' ' +
              podatki.data.ptt + ' ' + podatki.data.kraj
          this.hs2 = podatki.data.hs + podatki.data.hd
          this.trr = podatki.data.trr
          this.imePriimek = podatki.data.imePriimek
          this.metodaPlacila = podatki.data.acPayMethod
          if (podatki.data.datumFrom !== '') {
            this.zacetekSepa = ''
            this.zacetekSepa = podatki.data.datumFrom
          } else {
            this.zacetekSepa = '01.01.2001'
          }
          if (podatki.data.acPayMethod !== null) {
            if (podatki.data.acPayMethod === 'ZCc') {
              this.pridobljenaDirektnaBremenitev = true
              this.direktnaBremenitev = true
            } else if (podatki.data.acPayMethod === 'EBA') {
              this.pridobljenaeBanka = true
              this.eBanka = true
            } else if (podatki.data.acPayMethod === 'ZCe') {
              this.pridobljenaDirektnaBremenitev = true
              this.pridobljenaeBanka = true
              this.direktnaBremenitev = true
              this.eBanka = true
            } else {
              this.pridobljenaDirektnaBremenitev = true
              this.pridobljenaeBanka = true
              this.direktnaBremenitev = false
              this.eBanka = false
            }
          } else {
            this.direktnaBremenitev = false
            this.eBanka = false
          }
          if (this.pridobljenaDirektnaBremenitev === true &&
              this.eracunEmail === '' &&
              this.nacinObvescanjaStranke === 1) {
            this.statusObvescanje = 'Prosimo, vpišite e-naslov, na katerega želite prejemati račune.'
            this.ikonaStatusObvescanje = this.ikonaZaPrikazStatusaInfoTrikotnik
          }
          if (podatki.data.acPayMethod === 'EBA') {
            this.statusVrocanjaVspletnoBanko = this.vrocanjeRacunoEbankeVkljuceno + ' od ' + podatki.data.datumFrom
            this.ikonaZaPrikazStatusaVspletnoBanko = this.ikonaZaPrikazStatusaKljukica
            this.vrocanjeVSpletnoBanko = true
          } else {
            this.statusVrocanjaVspletnoBanko = this.vrocanjeRacunoEbankeIzkljuceno
            this.ikonaZaPrikazStatusaVspletnoBanko = this.ikonaZaPrikazStatusaInfoKrogec
          }
          if (podatki.data.acPayMethod === 'ZCc') {
            this.statusDirektnaBremenitev = this.direktnaBremenitevVkljucena + ' od ' + podatki.data.datumFrom
            this.ikonastatusDirektnaBremenitev = this.ikonaZaPrikazStatusaKljukica
          } else {
            this.statusDirektnaBremenitev = this.direktnaBremenitevIzkljucena
            this.ikonastatusDirektnaBremenitev = this.ikonaZaPrikazStatusaInfoKrogec
          }
          if (podatki.data.acPayMethod === 'ZCe') {
            this.statusDirektnaBremenitev = this.direktnaBremenitevVkljucena + '. Velja od ' + podatki.data.datumFrom
            this.statusVrocanjaVspletnoBanko = this.vrocanjeRacunoEbankeVkljuceno + '. Velja od ' + podatki.data.datumFrom
            this.ikonaZaPrikazStatusaVspletnoBanko = this.ikonaZaPrikazStatusaKljukica
            this.vrocanjeVSpletnoBanko = true
          }
          this.mozenPreklicSepa = podatki.data.mozenPreklic.toString()
          if ((this.direktnaBremenitev === true || this.eBanka === true) && this.currentDate.getDate() < 18 && this.mozenPreklicSepa === '0') {
            this.onemegocenObrazec = true
            this.onemogocenInfo = true
          } else if ((this.direktnaBremenitev === true || this.eBanka === true) && this.currentDate.getDate() >= 18 && this.mozenPreklicSepa === '0') {
            this.onemegocenObrazec = false
          } else if ((this.direktnaBremenitev === true || this.eBanka === true) && this.currentDate.getDate() >= 18 && this.mozenPreklicSepa === '1') {
            this.onemegocenObrazec = true
          }
          this.nalaganjeSepaPodatkov = false
        } else {
          this.nalaganjeSepaPodatkov = false
          this.statusVrocanjaVspletnoBanko = this.vrocanjeRacunoEbankeIzkljuceno
          this.statusDirektnaBremenitev = this.direktnaBremenitevIzkljucena
          this.naslovSpletnaBankaDirektnaBremenitev = ''
          this.hs2 = ''
        }
      }
    },
    ErrPridobitevTrenutnihStrankinihSEPApodatkov (podatki) {
      this.ShowSuccessMessage(podatki)
    },
    PreklicSepa () {
      MessageBox.confirm('Ali ste prepričani, da želite prekiniti SEPO?',
        {
          confirmButtonText: 'Da',
          cancelButtonText: 'Prekliči',
          confirmButtonClass: 'gumb-potrdi',
          cancelButtonClass: 'gumb-preklici',
          customClass: 'opozorilo-dialog'
        }).then(() => {
        let param = ['idStranka=' + this.izbranaStranka]
        this.clientAgent.postWsRequest(
          this,
          'stranka/eracun/preklicSepa',
          param,
          null,
          'SetPreklicSepa',
          'ErrPreklicSepa')
      }).catch((err) => {
        err = null
      })
    },
    SetPreklicSepa () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešen preklic SEPA.'
      this.ShowSuccessMessage(paramObvestilo)
      this.direktnaBremenitev = false
      this.onemegocenObrazec = true
      this.refreshPodatkov()
    },
    ErrPreklicSepa (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    NastavitevSEPApodatkovStrankeRacun () {
      let paramObvestilo = {}
      let trrValidator = new RegExp(/^\d+$/)
      if (this.trr === '' && (this.eBanka || this.direktnaBremenitev)) {
        paramObvestilo.message = 'Prosimo, vpišite podatke transakcijskega računa.'
        this.ShowWarningMessage(paramObvestilo)
      } else if ((this.trr.length !== 15 || !trrValidator.test(this.trr)) && (this.eBanka || this.direktnaBremenitev)) {
        paramObvestilo.message =
          'Nepravilno vneseni podatki transakcijskega računa. Prosimo, preverite in ustrezno izpolnite podatke.'
        this.ShowWarningMessage(paramObvestilo)
      } else if (this.imePriimek.length === 0) {
        paramObvestilo.message = 'Vnesite ime in priimek'
        this.ShowWarningMessage(paramObvestilo)
      } else if (this.naslovSpletnaBankaDirektnaBremenitev.length === 0) {
        paramObvestilo.message = 'Vnesite naslov za račun'
        this.ShowWarningMessage(paramObvestilo)
      } else if (!this.validacija.HisnaStevilkaValidation(this.hs2)) {
        paramObvestilo.message = 'Vnesite veljavno hišno številko.'
        this.ShowWarningMessage(paramObvestilo)
      } else if (!this.PreverjanjeNaslova(this.stalenNaslov)) {
        this.statusEracun = ('Prišlo je do napake pri preverjanju naslova.')
        paramObvestilo.message = 'Prišlo je do napake pri preverjanju naslova.'
        this.ShowWarningMessage(paramObvestilo)
      } else {
        let naslov = this.PreverjanjeNaslova(this.naslovSpletnaBankaDirektnaBremenitev)
        if (naslov.length === 6) {
          if (naslov[1] !== '' && naslov[2] !== '' && naslov[3] !== '' && naslov[4] !== '') {
            this.ulica = naslov[1]
            this.kraj = naslov[2]
            this.ptt = naslov[3]
            this.pKraj = naslov[4]
          } else if (naslov[1] !== '' && naslov[3] !== '' && naslov[4] !== '') {
            this.ulica = naslov[1]
            this.kraj = naslov[4]
            this.ptt = naslov[3]
            this.pKraj = naslov[4]
          } else {
            paramObvestilo.message = 'Vpisan naslov ni pravilen.'
            this.ShowWarningMessage(paramObvestilo)
            return false
          }
        }
        if (this.izbranaStrankaSap !== '') {
          if (this.metodaPlacila !== 'ZCc' && this.metodaPlacila !== 'ZCe' && this.metodaPlacila !== 'EBA') {
            let paramObvestilo = {}
            paramObvestilo.message = 'Nimate vključene direktne bremenitve ali vročanja preko E-BANKE'
            this.ShowWarningMessage(paramObvestilo)
            return false
          }
          let param = ['idStranka=' + this.izbranaStranka]
          param.push('trr=SI56' + this.trr)
          param.push('imePriimek=' + this.imePriimek)
          param.push('ulica=' + this.ulica)
          param.push('kraj=' + this.pKraj)
          param.push('ptt=' + this.ptt)
          param.push('hs=' + this.hs2)
          param.push('metodaPlacila=' + this.metodaPlacila)
          this.clientAgent.postWsRequest(
            this,
            'stranka/eracun/setSepaPodatki',
            param,
            null,
            'SetNastavitevSEPApodatkovStrankeRacunCallback',
            'ErrNastavitevSEPApodatkovStrankeRacunCallback')
        }
      }
    },
    SetNastavitevSEPApodatkovStrankeRacunCallback () {
      this.PridobitevTrenutnihStrankinihSEPApodatkov()
      if (this.direktnaBremenitev && this.eBanka) {
        this.ShowSuccessMessage({'message': 'Uspešno vklopljeno vročanje v eBanko in direktna obremenitev.'})
      } else if (this.eBanka) {
        this.ShowSuccessMessage({'message': 'Uspešno vklopljeno vročanje v eBanko.'})
      } else if (this.direktnaBremenitev) {
        this.ShowSuccessMessage({'message': 'Uspešno vklopljena direktna obremenitev.'})
      } else {
        this.ShowSuccessMessage({'message': 'Želene spremembe so uspešno izvedene.'})
      }
    },
    ErrNastavitevSEPApodatkovStrankeRacunCallback (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/MojT-2/Eposlovanje/EracunComponent.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MojT2/Eposlovanje/EracunComponent.vue